import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ReportItem } from './PdfImages';
import { toFitWidthThumbnailUrl, toPdfCardThumbnailUrl } from './pdfViewerUrl';

interface SortableImageProps {
  id: string;
  report: ReportItem;
  aspectRatio?: string;
  isChart?: boolean;
}

export const SortableImage = ({ id, report, aspectRatio = '8.5 / 11', isChart = false }: SortableImageProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={{ ...style, aspectRatio }}
      {...attributes}
      {...listeners}
      className="relative overflow-hidden rounded border border-strokedark bg-white"
    >
      <iframe
        src={isChart ? toFitWidthThumbnailUrl(report.image) : toPdfCardThumbnailUrl(report.image)}
        style={{
          height: '100%',
          width: '100%',
          border: 'none',
          pointerEvents: 'none', // Prevents iframe from interfering with drag
        }}
      />
    </div>
  );
}
